export const DEFAULT_VALUES = {
  name: '',
  industry: '',
  street: '',
  city: '',
  state: '',
  zip_code: '',
  primary_admin_full_name: '',
  primary_admin_phone_number: '',
  primary_admin_email: '',
  primary_admin_role: '',
};

export const INDUSTRIES = [
  { label: 'Restaurants', value: 'restaurants' },
  { label: 'Gas Stations', value: 'gas_stations' },
];

export const PLACEHOLDERS = {
  city: 'New York',
  state: 'NY',
  zip: '10001',
};

export const STEPS = [
  { id: 'info', label: 'Organization Detail' },
  { id: 'admin', label: 'Primary Administrator Contact' },
];

export const ONBOARDING_ORGANIZATION_MESSAGES = {
  SUCCESS: {
    TITLE: 'Organization created.',
    COPY: 'Your organization has been successfully created.',
  },
  ERROR: {
    TITLE: 'Failed to create organization.',
    COPY: 'We were unable to create your organization. Please try again.',
  },
};
